/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_ConnectedInputs */

const vi_customer_display_connected = /** @type {(inputs: Customer_Display_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết nối`)
};

/**

* @param {Customer_Display_ConnectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_connected = /** @type {((inputs?: Customer_Display_ConnectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_ConnectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_connected(inputs)
});